/* eslint-disable no-undef */
import { toast } from "react-toastify";
import API from "service/api";
import newApi from "service/newApi";
import qualityApi from "service/qualityApi";
import { CookieTool } from "utils/CookieTool";

const API_URL = process.env.REACT_APP_API_URL;
const API_KEY = process.env.REACT_APP_APIGEE_APIKEY;

export class SessionTool {
  static isTokenExpired(token) {
    if (!token.split(".")[1]) return true;
    const payload = JSON.parse(atob(token.split(".")[1]));
    const exp = payload.exp;
    return Date.now() >= exp * 1000;
  }

  static async renewSession() {
    try {
      const accessToken = CookieTool.getLarge("access_token");
      const refreshToken = CookieTool.getLarge("refresh_token");

      if (!accessToken || !refreshToken) {
        toast.error("Sessão inválida! Redirecionando para tela de login...", {
          toastId: "invalid-session",
        });
        setTimeout(() => {
          CookieTool.clearAuth();
          localStorage.clear();
          window.location.href = "/auth/login";
        }, 3000);
        return;
      }

      const response = await fetch(
        `${API_URL}/auth/refresh?apikey=${API_KEY}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ refreshToken }),
        },
      ).catch(() => {
        toast.error("Sessão expirada! Redirecionando para tela de login...", {
          toastId: "unauthorized-notification",
        });
        setTimeout(() => {
          CookieTool.clearAuth();
          localStorage.clear();
          window.location.href = "/auth/login";
        }, 3000);
      });

      const { access_token, refresh_token } = await response.json();

      const refreshExpiry = CookieTool.getTokenExpiry(refresh_token);
      CookieTool.setLarge("access_token", access_token, refreshExpiry);
      CookieTool.setLarge("refresh_token", refresh_token, refreshExpiry);

      API.defaults.headers["x-authorization"] = `Bearer ${access_token}`;
      qualityApi.defaults.headers["x-authorization"] = `Bearer ${access_token}`;
      newApi.defaults.headers["x-authorization"] = `Bearer ${access_token}`;
    } catch (error) {
      toast.error(
        "Erro ao renovar a sessão, por favor realize login novamente.",
        {
          toastId: "internal-error",
        },
      );
    }
  }

  static parseToken(token) {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  }
}
